import { NgModule } from "@angular/core";
import { registerLocaleData } from "@angular/common";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { provideNativeDateAdapter } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatStepperModule } from "@angular/material/stepper";
import localeAt from "@angular/common/locales/de-AT";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatBadgeModule } from "@angular/material/badge";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSliderModule } from "@angular/material/slider";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatMenuModule } from "@angular/material/menu";
import { MatTabsModule } from "@angular/material/tabs";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";

registerLocaleData(localeAt);

@NgModule({
  declarations: [],
  imports: [
    MatButtonModule,
    MatCheckboxModule,
    MatCardModule,
    MatInputModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatDialogModule,
    MatChipsModule,
    MatRadioModule,
    MatPaginatorModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatDatepickerModule,
    MatListModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatStepperModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatCardModule,
    MatSliderModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatMenuModule,
    MatTooltipModule,
    MatTabsModule,
    ReactiveFormsModule,
    FormsModule,
    FlexLayoutModule,
  ],
  exports: [
    MatButtonModule,
    MatCheckboxModule,
    MatCardModule,
    MatInputModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatDialogModule,
    MatChipsModule,
    MatRadioModule,
    MatPaginatorModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatDatepickerModule,
    MatListModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatStepperModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatBadgeModule,
    MatFormFieldModule,
    MatCardModule,
    MatSliderModule,
    MatProgressBarModule,
    MatMenuModule,
    MatTooltipModule,
    MatTabsModule,
    ReactiveFormsModule,
    FormsModule,
    FlexLayoutModule,
  ],
  providers: [provideNativeDateAdapter()],
})
export class MaterialModule {}
